export const ru = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Назад",
        save: "Сохранить",
        saved: "Сохранено",
        cancel: "Отмена",
        close: "Закрыть",
        accessDenied: "Доступ запрещен",
        noExportPermission: "У вас нет разрешения на экспорт данных этого автомобиля.",
        delete: "Удалить",
        downgrade: "Понизить",
        downgradeConfirm: "Вы уверены, что хотите перейти на бесплатный план?",
        edit: "Редактировать",
        loading: "Загрузка...",
        confirm: "Подтвердить",
        processing: "Обработка...",
        history: "История",
        currentCar: "Текущий автомобиль",
        purchasedCarTitle: "Покупка авто",
        initialCost: "Начальная стоимость",
        done: "Готово",
        ok: "ОК",
        error: "Ошибка",
        errorSaving: "Ошибка сохранения данных",
        mandatoryFieldsError: "Пожалуйста, заполните все обязательные поля правильно.",
        search: "Поиск",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Неверный формат электронной почты",
        today: "Сегодня",
        car: "Автомобиль",
        all: "Все",
        deleteConfirm: "Удалить",
        unsavedChangesTitle: "Несохраненные изменения",
        unsavedChangesMessage: "Вы хотите сохранить изменения перед выходом?",
        dontSave: "Не сохранять",
        additionalOptions: "Additional Options",
        add: "Добавить",
        fileTooLarge: "Файл слишком большой. Максимальный размер {limit} МБ.",
        storageFull: "Превышен лимит хранилища. Максимальный объем {limit} МБ.",
        dailyUploadLimit: "Достигнут дневной лимит загрузки ({limit} файлов/день). Попробуйте завтра.",
        hourlyUploadLimit: "Достигнут часовой лимит загрузки ({limit} файлов/час). Попробуйте через час.",
        fileCountLimit: "Максимум {limit} файлов разрешено на элемент.",
        emailParseLimitReached: "Достигнут лимит обработки электронной почты. Пожалуйста, обновите свой тарифный план или обработайте вручную.",
        emailLimitText: "Достигнут лимит обработки электронной почты.",
        monthlyEmailScans: "Ежемесячные сканирования электронной почты (Pro)",
        lifetimeEmailScans: "Пожизненные сканирования электронной почты (Бесплатно)",
        monthlyFileScans: "Ежемесячные сканирования квитанций (Pro)",
        lifetimeFileScans: "Пожизненные сканирования квитанций (Бесплатно)",
        fileLimitText: "Достигнут лимит сканирования квитанций.",
        planFreeTier: "Бесплатный тариф",
        planProTier: "Профессиональный тариф",
        uploadFailed: "Ошибка загрузки",
        attachments: "Вложения",
        limitsAndUsage: "Лимиты и использование",
        addresses: "адреса",
        emailCopied: "Адрес электронной почты скопирован!",
        units: {
            liters: "л",
            gallons: "гал",
            kilometers: "км",
            miles: "мили",
        },
        included: "Включено",
        proOnly: "Только для PRO",
        month: "мес",
        openInNewTab: "Открыть в новой вкладке",
        menu: "Меню",
        home: "Главная",
        monthsShort: {
            0: "Янв",
            1: "Фев",
            2: "Мар",
            3: "Апр",
            4: "Май",
            5: "Июн",
            6: "Июл",
            7: "Авг",
            8: "Сен",
            9: "Окт",
            10: "Ноя",
            11: "Дек",
        },
    },
    carMetadata: {
        bodyType: "Тип кузова",
        drivetrain: "Привод",
        transmission: "Трансмиссия",
        bodyTypes: {
            sedan: "Седан",
            hatchback: "Хэтчбек",
            wagon: "Универсал",
            suv: "Внедорожник",
            crossover: "Кроссовер",
            coupe: "Купе",
            convertible: "Кабриолет",
            pickup: "Пикап",
            van: "Фургон / Минивэн",
            commercial: "Коммерческий",
            other: "Другое",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "Передний привод",
            rwd: "Задний привод",
            awd: "Полный привод",
            other: "Другое",
        },
        transmissions: {
            not_specified: "-",
            manual: "Механическая",
            automatic: "Автоматическая",
            cvt: "CVT",
            other: "Другое",
        },
        otherLabel: "Другое (уточните)",
        mileageLabel: "Пробег",
    },
    auth: {
        welcome: "Добро пожаловать",
        welcomeBack: "С возвращением",
        signIn: "Войти",
        signInWithGoogle: "Войти через Google",
        signOut: "Выйти",
        magicLinkDesc: "Получите ссылку для входа на электронную почту",
        magicLinkSent: "Ссылка для входа отправлена!",
        magicLinkCheckEmail: "Проверьте свою почту и нажмите на ссылку, чтобы войти.",
        emailAddress: "Электронная почта",
        getMagicLink: "Получить ссылку",
        sending: "Отправка...",
        linkSent: "Ссылка отправлена",
        orContinueWith: "Или продолжить через",
        googleAccount: "Google аккаунт",
        newUserNote: "Впервые здесь? Ваша учетная запись будет создана автоматически после первого успешного входа.",
        magicLinkError: "Не удалось отправить ссылку. Пожалуйста, проверьте свою почту и попробуйте еще раз.",
        genericError: "Произошла ошибка. Пожалуйста, попробуйте еще раз.",
        projectDescription: "Отслеживайте расходы на автомобиль, обслуживание и историю в одном месте.",
        loginError: "Не удалось войти",
        loggingIn: "Вход...",
        authenticating: "Аутентификация...",
        authenticatingDesc: "Пожалуйста, подождите, пока мы защищаем вашу сессию.",
    },
    settings: {
        title: "Настройки",
        systemPreferences: "Системные настройки",
        appSettings: "Настройки приложения",
        dangerZone: "Опасная зона",
        theme: "Тема",
        language: "Язык интерфейса",
        currency: "Валюта",
        units: "Единицы измерения",
        distanceUnit: "Единица расстояния",
        volumeUnit: "Единица объема",
        expenseTypes: "Типы расходов",
        expenseTypesDesc: "Управление категориями",
        categories: "Категории",
        exportData: "Экспорт данных",
        exportDesc: "Скачать полный CSV",
        importData: "Импорт данных",
        importDesc: "Восстановить из резервной копии CSV",
        deleteAccount: "Удалить аккаунт",
        deleteAccountDesc: "Безвозвратно удалить все данные",
        enableSync: "Включить синхронизацию",
        enableSyncDesc: "Синхронизировать данные между устройствами",
        account: "Аккаунт",
        accountPlan: "План аккаунта",
        carsUsage: "Автомобили",
        carsLimitReached: "Достигнут лимит автомобилей",
        storageSize: "Размер хранилища",
        emailScans: "Сканирование по электронной почте",
        fileScans: "Сканирование квитанций",
        plans: "Планы",
        currentlyPlan: "В данный момент",
        upgradePlan: "Обновить",
        manageSubscription: "Управление подпиской",
        nextPayment: "Следующий платеж",
        endsOn: "Заканчивается",
        adminConsole: "Админ консоль",
        systemControl: "Управление системой",
        customCategories: "Пользовательские категории и метки",
        interfaceTheme: "Тема интерфейса",
        light: "Светлая",
        dark: "Темная",
        timezone: "Часовой пояс",
        timezoneDesc: "Используется для запланированных напоминаний по электронной почте",
        timeFormat: "Формат времени",
        timeFormat24h: "24-часовой (14:30)",
        timeFormat12h: "12-часовой (2:30 PM)",
        kilometers: "километры (км)",
        miles: "мили (мили)",
        liters: "литры (л)",
        gallons: "галлоны (гал)",
        accountManagement: "Управление аккаунтом",
        contactUs: "Связаться с нами",
        contactDesc: "Для предложений, запросов функций и вопросов",
        logOut: "Выйти",
        logOutConfirmTitle: "Выход",
        logOutConfirmMessage: "Вы уверены, что хотите выйти из своего аккаунта?",
        keepAccount: "Оставить аккаунт",
        deleteAccountConfirmTitle: "Удалить аккаунт",
        deleteAccountConfirmMessage: "Вы уверены, что хотите навсегда удалить свой аккаунт и все связанные данные об автомобилях? Это действие нельзя отменить.",
        deletePermanently: "Удалить навсегда",
        deleting: "Удаление...",
        contactSupport: "Служба поддержки",
        messageSent: "Сообщение отправлено!",
        feedbackThanks: "Благодарим за ваш отзыв. Мы ценим ваш вклад и обязательно его рассмотрим.",
        backToSettings: "Назад к настройкам",
        subjectLabel: "Тема",
        messageLabel: "Сообщение",
        subjectPlaceholder: "О чем это сообщение?",
        messagePlaceholder: "Расскажите нам о вашем предложении, запросе функции или вопросе...",
        enterSubjectAlert: "Пожалуйста, введите тему",
        enterMessageAlert: "Пожалуйста, введите сообщение",
        sendFailedAlert: "Не удалось отправить сообщение. Пожалуйста, попробуйте позже.",
    },
    export: {
        title: "Экспорт данных",
        generatePDF: "Сгенерировать PDF",
        carInformation: "Информация о машине",
        editInfo: "Отредактируйте информацию ниже, чтобы настроить ваш экспорт",
        editInfoHint: "Вы можете удалить или изменить любые поля, которые не хотите включать",
        filters: "Фильтры",
        expenseTypes: "Типы расходов",
        includeNotes: "Включить заметки",
        includeImages: "Включить файлы",
        hideDisabled: "Скрыть отключенные элементы",
        itemsCount: "{total} элементов, {selected} выбрано",
        selectAll: "Выбрать все",
        deselectAll: "Снять выбор со всех",
        expenses: "Расходы",
        notes: "Заметки",
        spareParts: "Запасные части",
        images: "Изображения",
        files: "Файлы",
        summary: "Итог",
        totalExpenses: "Общие расходы",
        totalItems: "Всего элементов",
        generatedOn: "Сгенерировано",
        noItemsSelected: "Нет выбранных элементов для экспорта",
        noItemsAvailable: "Нет доступных элементов для экспорта",
        generating: "Генерация PDF...",
        downloadPDF: "Скачать PDF",
        pdfFileName: "{carName}_экспорт_{date}.pdf",
        reportTitle: "Отчет о расходах на автомобиль",
        exportButton: "Экспорт",
        generateCSV: "Создать CSV",
        formatSelectorTitle: "Выберите формат",
        formatSelectorMsg: "Пожалуйста, выберите формат экспорта",
        proFeatureExportTitle: "Профессиональная функция: Экспорт данных",
        proFeatureExportDesc: "Обновите до PRO, чтобы экспортировать историю вашего автомобиля в PDF.",
        exportRestrictedPopup: "Экспорт данных доступен только для пользователей Pro.",
        allTypes: "Все типы",
        statistics: "Статистика",
        driven: "Проехано",
        since: "С",
        averageCost: "Средняя стоимость",
        perKm: "за км",
        perMile: "за милю",
        period: "Период",
        dateFrom: "С",
        dateTo: "По",
        allTime: "Сбросить фильтр",
        periodHint: "Если период не выбран — показываются все расходы",
        noExpenses: "Нет расходов, соответствующих фильтрам",
        expensesSection: "Расходы",
        attachmentsSection: "Вложения",
        imagesCount: "{count} изображений",
        pdfsCount: "{count} PDF-файлов",
        includeParts: "Включить запасные части",
        pageLabel: "Страница",
    },
    expenses: {
        title: "Расходы",
        newExpense: "Новый расход",
        editExpense: "Редактировать расход",
        openExpense: "Открыть запись расходов",
        details: "Детали расхода",
        selectType: "Выбрать тип",
        selectTypePlaceholder: "Выберите тип расхода...",
        shortDescriptionPlaceholder: "Краткое описание...",
        expenseTitle: "Название",
        logEntryTitleLabel: "Заголовок записи (необязательно)",
        defaultTitlePlaceholder: "По умолчанию - {type}",
        autoTitlePlaceholder: "Будет заполнено автоматически на основе выбранных типов",
        carDataTitle: "Данные автомобиля",
        defaultTitlePrefix: "Стандартное название будет -",
        addAnother: "Добавить другой вид расхода",
        addAnotherHint: "Если эта запись включает несколько видов расходов, вы можете добавить их все здесь для обеспечения точной статистики.",
        carValueDescription: "Оценочная рыночная стоимость автомобиля на данный момент.",
        type: "Тип",
        date: "Дата",
        amount: "Сумма",
        totalAmount: "Итого",
        splitCosts: "Разделить расходы?",
        combineCosts: "Объединить расходы",
        amountWork: "Сумма за работу",
        amountParts: "Сумма за запчасти",
        mileage: "Пробег",
        carValue: "Стоимость авто",
        description: "Описание",
        detailedDescription: "Подробное описание",
        electricity: "Электричество",
        fuelType: "Тип топлива",
        fuelTypeOptions: {
            petrol: "Бензин",
            diesel: "Дизель",
            lpg: "Газ (LPG)",
            electricity: "Электричество",
        },
        carData: "Данные автомобиля",
        images: "Файлы",
        addImages: "Добавить файлы",
        addImagesPDFs: "Добавить изображения или PDF",
        deleteExpense: "Удалить расход",
        deleteConfirm: "Вы уверены, что хотите удалить этот расход?",
        saveSuccess: "Расход успешно сохранен",
        thisExpense: "This Expense",
        stats: {
            annual: "Годовой",
            allTime: "За все время",
            avgMonth: "Сред/мес",
            costPer: "Цена/",
            noExpenses: "Расходов пока нет",
            dragToReorder: "Перетащите, чтобы изменить порядок",
        },
        expensesFound: "Расходы найдены!",
        noExpensesFound: "Расходы не найдены.",
        noDescription: "Нет описания",
        imagesCount: "Изображения ({count})",
        deleteImageTitle: "Удалить изображение",
        deleteImageConfirm: "Вы уверены, что хотите удалить это изображение? Это действие нельзя отменить.",
        typeLabels: {
            fuel: "Топливо",
            car_wash: "Мойка",
            repairs: "Ремонт",
            maintenance: "Обслуживание",
            parts: "Запчасти",
            insurance: "Страховка",
            inspection: "Техосмотр",
            tyres: "Шины",
            parking: "Парковка",
            electricity: "Электричество",
            taxes: "Налоги",
            other: "Другое",
            info: "Информация",
            service_maintenance: "Техническое обслуживание",
            service_repair: "Ремонт",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Сервис",
            selectSubtype: "Выберите тип",
            maintenance: "Техническое обслуживание",
            repair: "Ремонт",
            tuning: "Tuning",
        },
        timeLabel: "Время",
        addTimeLabel: "Добавить время",
        removeTimeLabel: "Удалить время",
    },
    repeatingExpenses: {
        title: "Повторяющиеся расходы",
        repeatToggle: "Повторять этот расход",
        repeatFrequency: "Частота",
        monthly: "Ежемесячно",
        startDate: "Дата начала",
        nextDate: "Следующая запись будет сгенерирована",
        endDate: "Дата окончания",
        noEndDate: "Без даты окончания",
        copyOptions: "Опции копирования",
        copyTitle: "Копировать название записи",
        copyLocation: "Копировать местоположение",
        copyDescription: "Копировать описание",
        active: "Активно",
        status: "Статус",
        managedByRepeat: "Этот расход является частью повторяющейся последовательности.",
        placeholder: "Здесь вы можете настроить автоматическое повторение для этого расхода, если он происходит регулярно с одной и той же суммой.",
        deleteRepeat: "Удалить повторение",
        deleteRepeatConfirm: "Вы уверены, что хотите остановить и удалить эту повторяющуюся последовательность? Будущие записи не будут сгенерированы. Прошлые записи останутся.",
        relatedEntries: "Записи в этой последовательности",
        stopRepeat: "Остановить повторение",
        isRepeating: "Повторяется",
        noTerm: "Неопределенно",
        until: "Последняя запись будет сгенерирована",
        summaryCopy: "Система скопирует",
        simulate: "Симулировать генерацию следующей записи",
        simulateSuccess: "Успешно смоделирована генерация следующей записи",
        simulateNoDate: "Больше нет дат для генерации (достигнута конечная дата)",
    },
    onboarding: {
        title: "Настройка профиля",
        welcome: "Добро пожаловать!",
        subtitle: "Настройте приложение под себя.",
        currency: "Валюта",
        preferredCurrency: "Предпочтительная валюта",
        distUnit: "Единица расстояния",
        volUnit: "Единица объема",
        complete: "Завершить настройку",
    },
    cars: {
        unitChangeWarningTitle: "Предупреждение о смене единиц",
        unitChangeWarningMessage: "Смена этих единиц не конвертирует ваши существующие данные. Все исторические записи останутся точно такими, как были введены.",
        unitChangeWarningConfirm: "Понял",
        title: "Гараж",
        carAdmins: "Администраторы автомобиля",
        sharedWithMe: "Поделено со мной",
        manageAdmins: "Управление администраторами",
        adminEmail: "Электронная почта администратора",
        addAdmin: "Добавить администратора",
        addAdminPlaceholder: "например, друг@email.com",
        removeAdmin: "Удалить",
        removeAdminConfirm: "Вы уверены, что хотите удалить этого администратора?",
        adminAdded: "Администратор добавлен",
        adminRemoved: "Администратор удален",
        removeMyAccess: "Удалить мой доступ",
        removeMyAccessConfirm: "Вы уверены, что хотите отказаться от доступа к этому автомобилю?",
        myAccessRemoved: "Доступ удален",
        noAdminsYet: "Пока нет добавленных администраторов.",
        adminInfoText: "Администраторы могут добавлять и редактировать расходы, заметки и запасные части, но не могут удалить сам автомобиль.",
        newCar: "Добавить авто",
        carNotFound: "Автомобиль не найден",
        carNotFoundDesc: "Запрашиваемый автомобиль не существует или у вас нет доступа.",
        accessDenied: "Доступ запрещен",
        accessDeniedDesc: "Этот автомобиль является частным и недоступен для общего доступа.",
        backToHome: "Вернуться на главную",
        adminRestricted: "Доступ ограничен",
        adminRestrictedDesc: "Только авторизованные администраторы могут получить доступ к этой консоли. Пожалуйста, вернитесь в основное приложение.",
        returnHome: "Вернуться на главную",
        editCar: "Редактировать авто",
        name: "Название авто",
        model: "Модель",
        year: "Год",
        plate: "Номерной знак",
        vin: "VIN номер",
        mileage: "Текущий пробег",
        initialMileage: "Начальный пробег",
        engineType: "Тип двигателя",
        tapToChangeIcon: "Нажмите, чтобы изменить иконку",
        chooseIcon: "Выберите значок",
        imageTab: "Изображение",
        iconTab: "Значок",
        chooseColor: "Выберите цвет",
        chooseEmoji: "Выберите эмодзи",
        uploadImage: "Загрузить изображение",
        clickToBrowse: "Нажмите, чтобы просмотреть файлы",
        currentCarIcon: "Значок текущего автомобиля",
        changeImage: "Изменить изображение",
        zoom: "Масштаб",
        rotate: "Повернуть",
        removeChangeImage: "Удалить / Изменить изображение",
        selectIcon: "Выбрать значок",
        cropAndSave: "Обрезать и сохранить",
        displayName: "Отображаемое имя",
        displayNamePlaceholder: "напр. Моя рабочая машина",
        makeLabel: "Марка *",
        modelLabel: "Модель *",
        yearLabel: "Год *",
        fuelTypeLabel: "Тип *",
        licensePlateLabel: "Номерной знак",
        vinLabel: "VIN",
        notesLabel: "Заметки (необязательно)",
        notesPlaceholder: "например, 1.6 TDI, 85kW, 1588cc, батарея 62kWh, AWD и т.д.",
        publicAccess: "Сделать авто публичным",
        publicAccessDesc: "Другие смогут просматривать это авто по ссылке",
        shareLocations: "Разрешить просмотр добавленных местоположений",
        shareLocationsDesc: "Включите это, чтобы сделать местоположения автомобилей видимыми в публичном доступе",
        deleteCar: "Удалить автомобиль",
        deleteCarTitle: "Удалить авто",
        deleteCarConfirm: "Вы уверены, что хотите удалить '{name}'? Это действие нельзя отменить.",
        noCars: "В вашем гараже нет автомобилей",
        addFirstCarNote: "Начните свой путь, добавив первый автомобиль для отслеживания расходов.",
        addVehicle: "Добавить авто",
        myVehicles: "Мои автомобили",
        favorites: "Избранное",
        deleteConfirm: "Вы уверены, что хотите удалить это авто? Все связанные расходы будут удалены.",
        deleteFailed: "Не удалось удалить авто",
        saveFailed: "Не удалось сохранить данные об авто",
        adminActions: "Админ действия",
        importCsv: "Импорт CSV",
        clearData: "Очистить данные",
        distanceUnitLabel: "Единица расстояния",
        volumeUnitLabel: "Единица объема",
        currencyLabel: "Валюта",
        boughtAt: "Дата покупки",
        purchasePrice: "Цена покупки",
        purchaseMileage: "Пробег при покупке",
        createPurchaseRecord: "Автоматически создать запись о покупке в истории",
        makePlaceholder: "напр., BMW",
        modelPlaceholder: "напр., X5",
        platePlaceholder: "напр., AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Эта информация создаст запись 'Информация' в истории автомобиля с указанными данными.",
        availableTypes: "Доступные типы",
        dragToReorder: "Перетащите для изменения порядка",
        requestTypeNote: "Если нужен еще какой-то тип - ",
        requestTypeAction: "сообщите нам!",
        emailProcessingTitle: "Обработка электронной почты",
        emailInstructions: "Перешлите ваши квитанции на адрес ниже. Мы автоматически извлечем данные и создадим расходы.",
        recentEmails: "Полученные письма",
        viewAllEmails: "ПОКАЗАТЬ ВСЕ ({count})",
        noEmailsReceived: "Пока нет полученных писем.",
        analysisResult: "Результат анализа",
        vehicleInfo: "Информация о транспортном средстве",
        preferences: "Настройки",
        purchaseHistory: "История покупок",
        emailProcessing: "Обработка электронной почты",
        publicAccessTitle: "Публичный доступ",
        expenseTypesTitle: "Типы расходов",
        adminActionsTitle: "Административные действия",
        enterPurchaseDateAlert: "Пожалуйста, введите дату покупки",
        allowedSenderEmails: "Разрешенные адреса электронной почты отправителей",
        allowedEmailsDesc: "Добавьте адреса электронной почты, которые могут отправлять квитанции этому автомобилю. Максимум 5 адресов.",
        noAllowedEmails: "Нет добавленных разрешенных адресов электронной почты.",
        emailAlreadyAdded: "Этот адрес электронной почты уже разрешен для этого автомобиля.",
        maxAllowedEmailsReached: "Достигнут максимальный лимит разрешенных адресов электронной почты.",
        addAllowedEmailPlaceholder: "Добавить разрешенный адрес электронной почты...",
        ownerEmail: "Владелец",
        onlyOwner: "только владелец",
        defaultAllowed: "Всегда разрешено",
        carLimitReachedTitle: "Достигнут лимит автомобилей",
        carLimitReachedMessage: "Ваш план {plan} позволяет {limit} автомобилям. У вас уже {current}. Перейдите в настройки, чтобы увидеть свои лимиты, или свяжитесь с нами для обновления.",
        carLimitGoToSettings: "Перейти в настройки",
        archivedCars: "Архивные",
        archiveCar: "Архивировать автомобиль",
        unarchiveCar: "Восстановить автомобиль",
        sellDate: "Дата продажи",
        sellPrice: "Цена продажи",
        sellMileage: "Пробег при продаже",
        archiveConfirm: "Вы уверены, что хотите архивировать этот автомобиль?",
        archiveInstructions: "Архивирование автомобиля означает, что он больше не ваш или вы больше не обслуживаете его. Пожалуйста, укажите детали продажи для статистики. Это сделает автомобиль доступным только для чтения.",
        archivedBadge: "Архивный",
        saleDetails: "Детали продажи",
        saleDetailsNote: "Детали продажи используются для статистики. Вы можете обновить их при необходимости.",
        archiveDetailsNotFillable: "Пожалуйста, заполните все поля для архивирования автомобиля",
        emailAddressWillBeAvailableAfterSave: "Адрес электронной почты будет доступен после сохранения автомобиля.",
        proFeatureAdminTitle: "Профессиональная функция: Администраторы автомобилей",
        proFeatureAdminDesc: "Добавьте других пользователей, которые могут просматривать и управлять данными этого автомобиля.",
        proFeatureEmailTitle: "Профессиональная функция: Дополнительные отправители",
        proFeatureEmailDesc: "Добавьте другие разрешенные адреса электронной почты, с которых могут быть отправлены квитанции на этот автомобиль.",
        estimatedMileage: "Оценочный пробег",
        summaryFrequencyLabel: "Частота сводки",
        summaryFrequencyOptions: {
            none: "Выключено",
            monthly: "Ежемесячно",
            semiAnnually: "Раз в полгода",
            annually: "Ежегодно",
        },
        healthProfilePrompt: "Заполните свой профиль здоровья для точного анализа!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Бензин",
        diesel: "Дизель",
        hybrid: "Гибрид",
        electric: "Электрический",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Тенденция пробега",
        title: "Статистика",
        allYears: "Все годы",
        totalSpent: "Всего потрачено",
        spentIn: "Потрачено в {year}",
        perMonth: "в месяц",
        overall: "всего",
        vsPrev12m: "пр. 12м.",
        rolling12m: "Посл. 12м.",
        byType: "По типу",
        byMonth: "По месяцам",
        byYear: "По годам",
        noData: "Нет данных за этот год",
        mostExpensive: "Самые дорогие",
        top: "Топ",
        untitled: "Без названия",
        assetAnalysis: "Анализ стоимости и затрат",
        burnNote: "* 'Общие потери' включают как потраченные деньги, так и оценочное снижение стоимости автомобиля.",
        carMarketValue: "Рыночная стоимость авто",
        cumulativeCosts: "Накопленные расходы",
        totalBurn: "Общие потери (Затраты + Амортизация)",
        entries: "записей",
        avgPrice: "Средняя цена",
        consumption: "Расход",
        price: "Цена",
        fuelPriceTrend: "Тенденция цен на топливо",
        spendingTrend: "Тенденция расходов",
        costPerKmTrend: "Стоимость за 1 км",
        costPerMileTrend: "Стоимость за 1 милю",
        serviceTrendsTitle: "Тренды обслуживания",
        expensesOnMap: "Расходы на карте",
        visitsCountLabel: "посещения",
        locationsSummary: "Сводка по местоположениям",
        locationsCountLabel: "места",
        noLocationsFoundTitle: "Местоположений пока нет",
        noLocationsFoundDesc: "Добавьте местоположения в ваши записи, чтобы увидеть их на карте.",
        addMileageData: "Добавить пробег",
        missingMileageInfo: "Недостаточно данных для расчета стоимости за расстояние. Добавьте как минимум 2 показания пробега за этот период (или одно до этого периода).",
        mileageModal: {
            title: "Добавить недостающий пробег",
            description: "Чтобы точно рассчитать расходы за расстояние за {year}, нам нужно знать пробег в начале и в конце года.",
            startOfYear: "Начало года (1 января)",
            endOfYear: "Конец года (31 декабря)",
            currentMileage: "Текущий пробег",
            placeholder: "Введите пробег...",
            save: "Сохранить данные",
            foundNearby: "Найдено рядом ({date}): {value} {unit}",
            useExisting: "Использовать это",
        },
        proAnalysis: "Профессиональный анализ",
        detailedAnalysis: "Подробный анализ",
        upgradeToSee: "Обновите, чтобы увидеть →",
    },
    tabs: {
        dashboard: "Обзор",
        expenses: "Расходы",
        stats: "Статистика",
        locations: "Местоположения",
        gallery: "Файлы",
        parts: "Запчасти",
        notes: "Заметки",
        repair: "Режим ремонта",
        'repair-switch': "Переключатель автомобиля",
    },
    repairAnalysis: {
        title: "Анализ решения о ремонте",
        ownershipLength: "Срок владения",
        currentValue: "Текущая стоимость",
        valueOutdated: "Стоимость может быть устаревшей",
        addValueToEnable: "Добавьте текущую стоимость автомобиля для включения анализа",
        totalInvested: "Всего инвестировано",
        totalInvestedSub: "Цена покупки + ремонты",
        totalExcludesFuel: "не включает топливо / электроэнергию",
        fuelLabelFuelOnly: "Общая стоимость топлива",
        fuelLabelEnergyOnly: "Общая стоимость энергии",
        fuelLabelHybrid: "Общая стоимость топлива и энергии",
        fuelTypeFuel: "топливо",
        fuelTypeEnergy: "электричество",
        fuelTypeHybrid: "топливо и электричество",
        fuelTotalLabel: "Общая стоимость топлива/энергии:",
        projectionMode: "Режим проекции",
        projectionModes: {
            lastYear: "На основе прошлого года",
            average: "Историческое среднее",
            trend: "Тенденция (линейная)",
        },
        brakeAssumption: "Обслуживание включает оценочный 3-летний цикл тормозов",
        repairBuffer: "Включает буфер риска ремонта на основе возраста",
        yearLabel: "год",
        totalInvestedDesc: "Цена покупки + все ремонты",
        repairToValue: "Ремонт к стоимости (12м)",
        repairToValueExplain: "Ремонт €{cost} против стоимости автомобиля €{value}. Менее 20% - это нормально; более 50% - высокий риск.",
        ownershipPressure: "Давление владения",
        ownershipPressureExplain: "Общее давление затрат: ремонты €{cost} + потеря стоимости против €{value}. Более 35% сигнализирует о финансовом стрессе.",
        investmentGap: "Инвестиционный разрыв",
        investmentGapExplain: "Всего инвестировано €{invested} минус текущая стоимость €{value}. Это показывает, сколько вы 'потеряли' на владении до сих пор.",
        investmentGapDesc: "Всего инвестировано - текущая стоимость",
        repairExpenses12m: "Стоимость ремонта за 12м",
        calculatedYearlyMileage: "Расчетный годовой пробег: {km} км",
        calculatedYearlyRepairs: "Расчетные годовые расходы на ремонт: {amount}",
        set: "Установить",
        plannedRepairCost: "Планируемая стоимость ремонта",
        whatIfTitle: "Что если вы потратите {amount} сейчас?",
        updatedScore: "Обновленный балл",
        updatedVerdict: "Обновленный вердикт",
        howIsItCalculated: "Как это рассчитывается?",
        usedLifespan: "Использовано: {usage}% от ожидаемого срока службы",
        remainingLifespan: "Осталось: ~{km} км",
        estimatedLifespan: "Ожидаемый срок службы: {km} км",
        lifecycle_stage_early: "Ранний этап жизненного цикла – низкий риск крупных поломок",
        lifecycle_stage_mid: "Средний этап жизненного цикла – нормальный износ",
        lifecycle_stage_late: "Поздний этап жизненного цикла – повышенный риск ремонтов",
        lifecycle_stage_end: "Конец ожидаемого срока службы – высокий риск крупных ремонтов",
        calculationExplanation: "Анализ использует цену покупки вашего автомобиля, недавние расходы на ремонт и оценочную текущую стоимость для расчета балла финансового здоровья. Высокие расходы на ремонт по сравнению со стоимостью автомобиля или быстрое обесценивание снизят балл.",
        confidenceLabel: "Уверенность",
        confidenceLevel: {
            high: "Высокая",
            medium: "Средняя",
            low: "Низкая",
        },
        mentalFactorsTitle: "Улучшите точность с помощью вашего опыта",
        mentalFactorsCTA: "Быстрая проверка (30 сек)",
        mentalFactorsSurveyTitle: "Ваш опыт",
        mentalFactorsSurveyDesc: "Ответьте на 3 быстрых вопроса, чтобы персонализировать ваш балл.",
        q1: "Соответствует ли ваш автомобиль вашим потребностям?",
        q1Help: "Пространство, комфорт, функции",
        q2: "Нравится ли вам водить ваш автомобиль?",
        q2Help: "Визуально, комфортно, ощущения",
        q3: "Беспокоит ли вас неожиданная поломка?",
        q3Help: "Проблемы с надежностью",
        q4: "Это авто для семьи и дальних поездок?",
        q4Help: "Приоритет безопасности и надежности",
        factorsTitle: "Факторы оценки",
        factorsDesc: "Посмотрите, что влияет на ваш балл",
        newCarComparison: "Сравнение с новым автомобилем",
        newCarComparisonDesc: "Сравните ваши текущие ежемесячные расходы с покупкой нового автомобиля.",
        modeLeasing: "Лизинг",
        modeFullPrice: "Полная цена",
        downPayment: "Первоначальный взнос",
        leaseYears: "Срок (лет)",
        monthlyPayment: "Ежемесячный платеж",
        carPrice: "Полная цена автомобиля",
        ownershipYears: "Планируемый срок владения (лет)",
        insuranceMonthly: "Ежемесячный CASCO / Страхование",
        currentMonthlyCost: "Текущие авторасходы",
        newCarMonthlyCost: "Стоимость нового автомобиля",
        newCarCheaper: "Новый автомобиль дешевле на: {amount} / мес",
        newCarMoreExpensive: "Новая машина дороже на: {amount} / мес",
        newCarSameCost: "Расходы абсолютно одинаковые.",
        advancedSettings: "Расширенные настройки",
        yearlyMaint: "Годовое обслуживание (€)",
        tyres3Yrs: "Шины / 3 года (€)",
        depreciation5Yrs: "Амортизация (5 лет %)",
        newCarYear: "Год новой машины",
        cumulativeCosts: "Совокупные расходы (Прогноз)",
        comparisonByYear: "Сравнение по годам",
        currentCarLabel: "Текущая машина",
        newCarLabel: "Новая машина",
        resaleValue: "Стоимость перепродажи",
        startupCosts: "Начальные расходы (подержанный автомобиль)",
        inspection: "Предварительная проверка перед покупкой",
        initialMaintenance: "Первоначальное обслуживание + масла",
        registration: "Регистрация / Сборы",
        total: "Итого",
        currentCarTitle: "Текущий автомобиль",
        newCarTitle: "Потенциальный автомобиль",
        upfrontInvestment: "Первоначальные инвестиции",
        monthlyReality: "Реальная ежемесячная стоимость",
        depreciationShort: "Амортизация",
        howCalculated: "Как это рассчитывается?",
        deltaMonthly: "Ежемесячная разница",
        deltaUpfront: "Первоначальная разница",
        surveyMeanings: {
            practical: {
                1: "Совсем не подходит",
                2: "Плохо подходит",
                3: "Средне",
                4: "Хорошо подходит",
                5: "Идеально подходит",
            },
            joy: {
                1: "Разочаровывающе",
                2: "Скучно",
                3: "Средне",
                4: "Приятно",
                5: "Очень приятно",
            },
            worry: {
                1: "Не беспокоюсь",
                2: "Немного беспокоюсь",
                3: "Беспокоюсь",
                4: "Очень беспокоюсь",
                5: "Уверен, что сломаюсь в любой момент",
            },
        },
        verdicts: {
            KEEP: "Финансово целесообразно оставить",
            borderline: "На грани – внимательно следите",
            sell: "Высокий финансовый риск – продажа может быть разумной",
        },
        factors: {
            trendInc: "Растущая тенденция",
            trendIncDesc: "Расходы на ремонт растут по сравнению с прошлым годом.",
            lowDepreciation: "Преимущество низкой амортизации",
            lowDepreciationDesc: "Старые/дешевые автомобили теряют меньше стоимости со временем.",
            stableRepairs: "Стабильные ремонты",
            stableRepairsDesc: "Ваши расходы на ремонт стабильны или уменьшаются.",
            noHistoricalData: "Нет данных старше 6 месяцев.",
            lifecycle_stage: "Этап жизненного цикла автомобиля",
            high_risk_phase: "Фаза высокого риска",
            high_risk_phase_desc: "Комбинация позднего этапа жизненного цикла и растущих расходов на ремонт указывает на высокий риск.",
            lowCostKm: "Эффективная стоимость за км",
            lowCostKmDesc: "Общая эффективность эксплуатации этого автомобиля отличная.",
            lowFixedCosts: "Низкие фиксированные расходы",
            lowFixedCostsDesc: "Ваши фиксированные расходы (налоги, страховка) низкие.",
            usage: "Годовое использование",
            usageDesc: "Расстояние, пройденное за последние 12 месяцев.",
            accidentMinor: "Незначительная авария",
            accidentMinorDesc: "Косметические повреждения или небольшие ремонты.",
            structuralDamage: "Структурные повреждения",
            structuralDamageDesc: "Проблемы с рамой или структурой резко снижают стоимость.",
            aiLifespanNearEnd: "Конец ожидаемого срока службы",
            aiLifespanAging: "Стареющие компоненты",
            aiLifespanGood: "Преимущество низкого пробега",
            aiLifespanDesc: "На основе оцененного ИИ типичного срока службы для этой модели.",
            aiUpcomingRepairs: "Предстоящие ремонты (прогноз ИИ)",
            aiUpcomingRepairsDesc: "ИИ прогнозирует крупные поломки компонентов в ближайшее время на основе пробега.",
            ownershipFatigue: "Усталость от владения",
            ownershipFatigueLong: "Долгосрочное владение часто приводит к психологической готовности к другому автомобилю.",
            ownershipFatigueShort: "Начальная предвзятость к владению создает более сильную тенденцию сохранить автомобиль.",
            family_priority: "Семья и дальние поездки",
            replacement_comparison: "Сравнение замены",
            none: "Нет",
            surface: "Поверхностный",
            minor: "Незначительный",
            moderate: "Умеренный",
            severe: "Серьезный",
            structural: "Структурный",
            major: "Крупный",
            critical: "Критический",
            full: "Полный",
            improveLabel: "Что могло бы улучшить это:",
            info_original_price: "Приблизительная цена этого автомобиля, когда он был новым. Помогает оценить стабильность стоимости. Старые автомобили с низкой остаточной стоимостью более безопасны с финансовой точки зрения.",
            info_current_value: "Сколько вы могли бы продать его сегодня. Используется для проверки, являются ли расходы на ремонт большой частью стоимости автомобиля, что сигнализирует о плохих инвестициях.",
            info_yearly_mileage: "Более высокий пробег увеличивает износ. Низкий пробег может значительно продлить срок службы автомобиля.",
            info_estimated_repairs: "Текущие расходы на поддержание автомобиля в рабочем состоянии. Высокие годовые расходы снижают привлекательность сохранения автомобиля.",
            info_planned_repairs: "Известные предстоящие ремонты. Симулирует немедленное давление на ваше решение.",
            info_ownership_years: "Как долго вы владеете этим автомобилем? Это влияет на психологическую усталость от владения и предвзятость первоначального покупателя.",
            info_rust: "Критический долгосрочный риск. Структурная ржавчина снижает безопасность. Серьезная ржавчина делает продажу лучшим вариантом.",
            info_crashes: "Структурные аварии влияют на безопасность и надежность. Они также значительно снижают стоимость перепродажи.",
            info_repaint: "Сигнализирует о прошлом повреждении или косметических исправлениях. Небольшое влияние, если более глубокие проблемы были скрыты.",
            info_unresolved: "Скрытые будущие расходы. Известные неисправности в электронике, двигателе или обслуживании, которые требуют внимания.",
            info_fit: "Подходит ли автомобиль вашим потребностям (пространство, комфорт)? Плохая совместимость означает, что вы с большей вероятностью замените его.",
            info_joy: "Эмоциональная ценность имеет значение. Отсутствие радости означает, что вы психологически готовы к новому автомобилю.",
            info_worry: "Стресс восприятия надежности. Высокая тревога является сильным сигналом для замены автомобиля.",
        },
        explanations: {
            repairFreq: "Ваш автомобиль прошел {visits} сервисных визитов за последние 12 месяцев. Частые визиты указывают на низкую надежность и высокие неудобства.",
            repairVsValue: "За последние 12 месяцев ваши ремонты стоили €{cost}, в то время как оценочная стоимость автомобиля составляет €{value}. Это {ratio}% от общей стоимости автомобиля.",
            stableRepairsDetailYearly: "В прошлом году вы потратили €{cost1} на ремонт, но годом ранее €{cost2}. Изменение на {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "За последние 6 месяцев вы потратили €{cost1}, за предыдущие 6 месяцев €{cost2}. Изменение на {percent}% ({trend}).",
            mileage: "На {mileage} км автомобиль попадает в зону повышенного риска крупных поломок (трансмиссия, компоненты двигателя).",
            planned: "У вас есть €{cost} в запланированных ремонтах, что немедленно снижает финансовую безопасность удержания автомобиля.",
            lowDep: "Автомобили стоимостью около €{value} теряют очень мало стоимости в год, компенсируя более высокие расходы на ремонт.",
            depRisk: "Вашему автомобилю {age} лет, и он в основном завершил свой цикл амортизации, что означает, что вы не теряете деньги из-за падения его стоимости.",
            stable: "Вы потратили €{costThisYear} в этом году по сравнению с €{costLastYear} в прошлом году, что является снижением на {percent}%. Предсказуемые расходы математически выгодны.",
            costKm: "Вы проехали {km} км в прошлом году. Эксплуатационные расходы составили €{costKm} за километр, что показывает отличную экономическую эффективность.",
            fixedCosts: "Вы заплатили €{costs} в фиксированных ежегодных расходах (страховка/налог). Этот низкий уровень расходов дает дополнительное спокойствие.",
            usage: "Вы проезжаете около {km} км в год на основе ваших записей.",
            practical_fit: "Вы оценили практическое соответствие на {score}/5, скорректировав математическую оценку на {impact} пунктов.",
            emotional_satisfaction: "Вы оценили свое эмоциональное удовлетворение на {score}/5, скорректировав оценку на {impact} пунктов.",
            reliability_anxiety: "Ваша уверенность в надежности составляет {score}/5, влияя на оценку на {impact} пунктов.",
            rust: "Серьезная структурная или подкоррозия обычно означает угрозы безопасности или сценарии списания.",
            accident: "Предыдущие повреждения, в зависимости от степени серьезности, по сути снижают стоимость перепродажи и безопасность автомобиля.",
            structural: "Структурные проблемы автоматически делают автомобиль финансово опасным.",
            ai_lifespan: "На {current} км автомобиль завершил {ratio}% своего оцененного ИИ срока службы ({expect} км).",
            ai_repairs: "Данные ИИ указывают на то, что {count} типичных крупных ремонтов для этой модели, как правило, происходят на этом пробеге.",
            lifecycle_stage: "Что означает срок службы? {total} км – это предсказанная ИИ точка, когда обычно начинаются крупные структурные ремонты (двигатель, коробка передач и т.д.) для этой модели. Это не конец жизни автомобиля – он все еще может ездить, но с значительно более высокими расходами на обслуживание. Полный физический срок службы типичного автомобиля составляет 500k–1M км, но он становится экономически нецелесообразным гораздо раньше.",
        },
        ratios: {
            healthy: "Здоровый",
            monitor: "Мониторинг",
            highRisk: "Высокий риск",
            stable: "Стабильный",
            warning: "Предупреждение",
            financialStress: "Финансовый стресс",
        },
        proFeatureTitle: "Профессиональная функция: Режим ремонта",
        proFeatureDesc: "Разблокируйте движок принятия решений, чтобы получить профессиональный финансовый анализ ваших автомобильных ремонтов. Бесплатные пользователи видят демонстрацию с образцовыми данными.",
        viewDemo: "Посмотреть живую демонстрацию",
        upgradeToUnlock: "Обновите до PRO, чтобы проанализировать ваш автомобиль",
    },
    carTasks: {
        title: "Задачи по автомобилю",
        placeholderTitle: "Отслеживание обслуживания",
        placeholderDesc: "График обслуживания для вашей модели автомобиля.",
        demoTitle: "Задачи по обслуживанию автомобиля",
        demoSubtitle: "Умное отслеживание для вашего автомобиля",
        feature1Title: "Автоматическая генерация задач",
        feature1Desc: "Автоматически генерирует задачи, такие как замена масла, замена фильтров и проверка ремня ГРМ на основе модели вашего автомобиля.",
        feature2Title: "Интеграция расходов",
        feature2Desc: "Анализирует вашу историю обслуживания, чтобы понять, что уже было сделано и когда.",
        feature3Title: "Умные напоминания",
        feature3Desc: "Получайте уведомления как по времени, так и по пробегу. Отслеживание сбрасывается автоматически, когда вы отмечаете задачу как выполненную.",
        getStarted: "Начать",
        fakeDoorPopupTitle: "Ваши отзывы приветствуются",
        fakeDoorPopupMessage: "Мы в настоящее время разрабатываем задачи по обслуживанию автомобилей. Эта функция позволит вам автоматически отслеживать интервалы обслуживания. Какие конкретные задачи или функции вы хотели бы видеть больше всего?",
        fakeDoorPopupPlaceholder: "Ваши мысли...",
        noTasksYet: "Пока нет задач",
        deleteAllTitle: "Очистить список задач?",
        deleteAllMessage: "Вы уверены, что хотите удалить все {count} задач для этого автомобиля? Это действие нельзя отменить.",
        deleteAllSuccess: "Все задачи были успешно удалены.",
        sortPriority: "Приоритет",
        sortType: "Тип",
        sortDate: "Последние",
        status: {
            overdue: "ПРОСРОЧЕНО",
            pending: "ОЖИДАЕТ",
            noData: "НЕТ ДАННЫХ",
            upcoming: "Предстоящие",
            nextIn: "Следующее через {dist} {unit}",
            overdueBy: "{dist} {unit} просрочено",
            afterDays: "Через {days} дней",
            overdueDays: "{days} дней просрочено",
        },
        form: {
            newTitle: "Новая задача",
            actionType: "Проверить или заменить?",
            intervalMonths: "Интервал (Месяцы)",
            intervalDistance: "Интервал (Расстояние)",
            diffFirstInterval: "Первый интервал отличается от базового интервала",
            firstInterval: "Первый интервал",
            historyToggle: "Эта задача когда-либо выполнялась для этого автомобиля?",
            historyToggleDesc: "Если НЕТ, мы предполагаем, что она никогда не выполнялась с момента производства.",
            lastPerformedOptional: "Когда она была выполнена в последний раз? (Необязательно)",
            deleteTitle: "Удалить задачу",
            deleteConfirm: "Вы уверены, что хотите удалить эту задачу?",
            saveError: "Не удалось сохранить задачу",
            historyConfirmed: "История подтверждена",
            reminders: "Напоминания",
            notifyMileage: "Уведомить меня, когда будет достигнут расчетный пробег",
            notifyDate: "Уведомить меня, когда наступит дата",
            nextMileageReminder: "Расчетная дата",
            nextDateReminder: "Срок выполнения",
            estimatedDate: "Предполагаемая дата",
            missingLastMileage: "Отсутствует последний пробег",
            missingLastDate: "Отсутствует последняя дата",
            missingStartDate: "Не удалось определить дату начала",
            additionalOptions: "Дополнительные параметры",
            reminderInfoMissing: "Информационное состояние: напоминания отключены до предоставления последних выполненных данных.",
        },
    },
    dashboard: {
        title: "Обзор",
        quickActions: "Быстрые Действия",
        addExpense: "Добавить расход",
        editCar: "Редактировать авто",
        recentExpenses: "Расходы",
        seeAll: "Посмотреть все",
        recentGallery: "Файлы",
        thisMonth: "В этом месяце",
        totalSpent: "Всего потрачено",
        avgPerMonth: "В среднем/мес",
        recentNotes: "Заметки",
        recentParts: "Запчасти",
        noRecentExpenses: "Нет недавних расходов",
        noRecentGallery: "Нет недавних фото",
        noRecentNotes: "Нет недавних заметок",
        noRecentParts: "Нет недавних запчастей",
        createNote: "Создать новое",
        createPart: "Создать новое",
        createExpense: "Создать новое",
        noFiles: "Пока нет добавленных файлов",
        needSomethingMore: "Нужна еще помощь?",
        letUsKnow: "сообщите нам!",
    },
    expenseTypes: {
        editTitle: "Изменить тип расхода",
        newTitle: "Новый тип расхода",
        categoryName: "Название категории",
        placeholderName: "напр. Сервис",
        signatureColor: "Фирменный цвет",
        icon: "Иконка категории",
        deleteConfirm: "Вы действительно хотите удалить тип '{name}'?",
    },
    spareParts: {
        title: "Запчасти",
        connectedWithRecords: "Связано с записями",
        toBuy: "Купить",
        usedInExpenses: "Использовано в расходах",
        noPartsToBuy: "Запчасти не добавлены в список покупок",
        noPartsUsed: "Запчасти пока не привязаны к расходам",
        quantity: "Кол-во",
        partCode: "Код детали",
        price: "Цена",
        link: "Ссылка",
        comment: "Комментарий",
        addPart: "Добавить запчасть",
        editPart: "Редактировать запчасть",
        openPart: "Открыть запись детали",
        nameLabel: "Название",
        manufacturerLabel: "Производитель",
        priceLabel: "Цена ({currency})",
        imagesLabel: "Изображения и файлы (первое — основное)",
        linkedHistory: "Связанная история",
        partManagedNote: "Эта деталь управляется через расход",
        cannotDeleteNote: "* Поскольку эта деталь связана с расходом, ее нельзя удалить отдельно. Удалите или отредактируйте расход для управления этой деталью.",
        partNamePlaceholder: "Название детали...",
        manufacturerPlaceholder: "Bosch, Brembo и т.д.",
        additionalInfoPlaceholder: "Дополнительная информация...",
        namePlaceholder: "напр. Тормозные колодки",
        codePlaceholder: "напр. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Сохранить деталь",
        deletePart: "Удалить деталь",
        deleteConfirm: "Вы уверены, что хотите удалить эту запчасть?",
        sparePartsLabel: "Запчасти",
        partNumber: "Деталь #{number}",
        imagesLimitLabel: "Файлы (до 5)",
        optional: "(необязательно)",
        selectPart: "Выбрать запасную часть",
        createNew: "Создать новую запасную часть",
        searchPlaceholder: "Поиск по имени или коду...",
        noResults: "Запчасти не найдены",
        noPartsYet: "Пока нет запчастей. Создайте первую!",
        selectorDescription: "Найдите и выберите существующую запасную часть или создайте новую",
        alreadyAdded: "Эта деталь уже добавлена",
        statistics: {
            avgPrice: "Средняя",
            lastPrice: "Последняя",
            usedTimes: "Использовано {count} раз",
            totalPurchased: "Всего: {quantity}x",
        },
        usage: {
            title: "Additional Usage Info",
            quantity: "Количество",
            pricePerUnit: "Price / Unit",
            comment: "Комментарий",
            commentPlaceholder: "e.g. Bought at AutoZone",
            total: "Итого",
            transactionData: "Эта транзакция",
        },
        masterData: "Основная информация о детали",
        masterRecord: {
            title: "Master Part Details (Shared)",
            editMaster: "Редактировать основную запись",
            warning: "Changes to the master record affect all usages",
        },
    },
    reminders: {
        title: "Напоминания",
        reminder: "Напоминание",
        noteReminder: "Напоминание о заметке",
        partReminder: "Напоминание о детали",
        today: "Сегодня",
        tomorrow: "Завтра",
        yesterday: "Вчера",
        inXDays: "через {x} дней",
        xDaysAgo: "{x} дней назад",
        inXMonths: "через {x} месяцев",
        xMonthsAgo: "{x} месяцев назад",
        active: "Активно",
        activeDesc: "При необходимости вы можете отключить это напоминание, не удаляя его",
        disabled: "Отключено",
        yearly: "Ежегодно",
        markSeen: "Подтвердить",
        addReminder: "Новое напоминание",
        editReminder: "Редактировать напоминание",
        extraReminders: "Дополнительные напоминания",
        extraRemindersDesc: "Отправить еще 3 напоминания в следующие дни (всего 4), если не остановить.",
        remindDate: "Дата",
        remindTime: "Время",
        repeatYearly: "Повторять ежегодно",
        repeatYearlyDesc: "Это напоминание будет автоматически происходить каждый год в ту же дату/месяц/день/время, пока не будет отключено",
        standalone: "Отдельные напоминания",
        embedded: "Связанные напоминания",
        noReminders: "Нет активных напоминаний",
        deleteReminder: "Удалить напоминание",
        nameLabel: "Имя",
        descriptionLabel: "Описание",
        namePlaceholder: "Имя напоминания",
        descriptionPlaceholder: "Краткое описание или заметка",
        simulateReminder: "Симулировать момент напоминания",
        simulateSuccess: "Электронное письмо о симуляции отправлено",
        timezone: "Часовой пояс",
        nextReminder: "Следующее напоминание",
        futureTimeError: "Время напоминания должно быть в будущем",
    },
    notes: {
        title: "Заметки",
        emptyNote: "Пустая заметка",
        noNotes: "Заметок пока нет",
        addNote: "Добавить заметку",
        editNote: "Редактировать заметку",
        viewNote: "Просмотреть заметку",
        openNote: "Открыть запись заметки",
        titleLabel: "Заголовок",
        contentLabel: "Содержание",
        noteTitlePlaceholder: "Заголовок заметки...",
        noteContentPlaceholder: "Напишите свою заметку здесь...",
        saveNote: "Сохранить заметку",
        deleteNote: "Удалить заметку",
        publicNote: "Сделать заметку публичной",
        publicNoteDesc: "Другие смогут просматривать эту заметку по ссылке",
        deleteConfirm: "Вы уверены, что хотите удалить эту заметку?",
        enterTitleAlert: "Пожалуйста, введите заголовок",
        saveFailed: "Не удалось сохранить заметку",
        thisNote: "This Note",
        deleteFailed: "Не удалось удалить заметку",
        pinToTop: "Pinned to Top",
    },
    locations: {
        title: "Местоположения",
        singleTitle: "Местоположение",
        newLocation: "Новое местоположение",
        emptyLocation: "Пустое местоположение",
        noLocations: "No locations yet",
        addLocation: "Добавить местоположение",
        editLocation: "Редактировать местоположение",
        viewLocation: "Просмотреть местоположение",
        openLocation: "Открыть местоположение",
        createNew: "Создать новое местоположение",
        selectLocation: "Выбрать местоположение",
        searchLocations: "Поиск местоположений...",
        nameLabel: "Название",
        addressLabel: "Адрес или координаты",
        descriptionLabel: "Комментарий/Описание",
        namePlaceholder: "например, Сервис в центре",
        mapLabel: "Местоположение",
        searchPlaceholder: "Поиск адреса...",
        addressPlaceholder: "Введите адрес и выберите...",
        descriptionPlaceholder: "Дополнительная информация...",
        fillAddress: "Заполнить адрес с карты",
        saveLocation: "Сохранить местоположение",
        deleteLocation: "Удалить местоположение",
        deleteConfirm: "Вы уверены, что хотите удалить это местоположение?",
        enterNameAlert: "Пожалуйста, введите название",
        saveFailed: "Не удалось сохранить местоположение",
        thisLocation: "Это местоположение",
        deleteFailed: "Не удалось удалить местоположение",
        myLocations: "Мои местоположения",
        usedInEntries: "Используется в записях",
        noEntries: "Местоположение не используется",
        noEntriesThisCar: "Это местоположение не использовалось для этого автомобиля",
        removeLocation: "Удалить местоположение",
        noResults: "Результатов не найдено",
    },
    gallery: {
        title: "Файлы",
        noImages: "Изображения не добавлены",
        addImagesNote: "Добавьте изображения к авто или расходам",
        totalImages: "Всего {count} изображений",
        imageAlt: "Изображение {number}",
        commentPlaceholder: "File comment (optional)",
        isReceipt: "Этот файл является чеком",
        deleteImageTitle: "Удалить файл",
        deleteImageConfirm: "Вы уверены, что хотите навсегда удалить этот файл?",
    },
    search: {
        placeholder: "Поиск расходов, запчастей, заметок...",
        typeToSearch: "Начните вводить для поиска",
        noResults: "Ничего не найдено по запросу '{query}'",
        carImage: "Изображение автомобиля",
        expenseImage: "Изображение расхода",
        noteImage: "Изображение заметки",
        galleryImage: "Изображение галереи",
        untitledExpense: "Расход без названия",
    },
    landing: {
        nav: {
            features: "Особенности",
            howItWorks: "Как это работает",
            pricing: "Цены",
            login: "Войти",
            getStarted: "Начать",
            garage: "Гараж",
        },
        hero: {
            title: "Знайте точно, сколько стоит ваш автомобиль",
            subtitle: "На самом деле",
            description: "Отслеживайте расходы, фиксируйте ремонты и смотрите, куда на самом деле уходят ваши деньги.",
            subheadline: "Профессиональная панель управления на основе данных для тщательных владельцев автомобилей.",
            startTracking: "Начать",
            viewDemo: "Демо Автомобиль ->",
            trustSignal: "Присоединяйтесь к 1,200+ тщательным владельцам, которые уже отслеживают более 5 миллионов километров реальных затрат на автомобили.",
            ctaNote: "Без кредитной карты. Без навязчивых продаж. Только ясность.",
            benefits: {
                repairVsSell: {
                    title: `Ремонт против продажи`,
                    description: `Определите порог "Ремонт против продажи" — прекратите гадать, не выбрасываете ли вы деньги в бездонную яму. Узнайте точный момент, когда ремонт больше не является разумной инвестицией.`
                },
                costPerKm: {
                    title: `Стоимость за км`,
                    description: `Отслеживайте свои реальные затраты за километр — выходите за пределы панели управления. Увидьте полную финансовую картину ваших привычек вождения, которую другие приложения упускают.`
                },
                automation: {
                    title: `Автоматизация`,
                    description: `Автоматизируйте ведение записей — просто пересылайте свои счета или просто отправляйте свои заметки по электронной почте. Наш ИИ организует техническую историю вашего автомобиля для вас.`
                }
            },
        },
        features: {
            title: "Все, что нужно для управления авто",
            subtitle: "Хватит использовать таблицы и хаотичные папки. My Car Costs дает профессиональные инструменты управления автопарком для вашего личного гаража.",
            expenseTracking: {
                title: "Отслеживание расходов",
                description: "Регистрируйте топливо, сервис, страховку и ремонт. Категоризируйте затраты и визуализируйте тренды.",
            },
            spareParts: {
                title: "Менеджер запчастей",
                description: "Ведите детальный учет запчастей, их номеров и заметок о совместимости для всех видов ремонта.",
            },
            serviceHistory: {
                title: "История сервиса и заметки",
                description: "Цифровая сервисная книжка. Добавляйте подробные заметки об обслуживании, модификациях и планах.",
            },
            documentStorage: {
                title: "Хранилище документов",
                description: "Загружайте чеки, счета и фото вашего авто. Храните всю документацию в безопасности и под рукой.",
            },
            emailForwarding: {
                title: "Пересылка по Email",
                description: "Пересылайте счета прямо на ваш уникальный адрес. Мы автоматически извлечем данные.",
            },
            multiCar: {
                title: "Гараж на несколько авто",
                description: "Управляйте одной машиной или целым парком. Переключайтесь между авто мгновенно.",
            },
            repeatingExpenses: {
                title: "Повторяющиеся расходы",
                description: "Автоматизируйте отслеживание регулярных ежемесячных расходов, таких как страховка, парковка или аренда.",
            },
            smartReminders: {
                title: "Умные напоминания",
                description: "Установите пользовательские оповещения для запасных частей и сервисных заметок, чтобы никогда не пропустить задачу по обслуживанию.",
            },
        },
        howItWorks: {
            title: "Простой и мощный процесс",
            step1: {
                title: "Добавьте автомобиль",
                description: "Введите данные вашего авто, чтобы создать цифровой гараж.",
            },
            step2: {
                title: "Регистрируйте чеки и файлы",
                description: "Сфотографируйте чек или перешлите email. Остальное мы берем на себя.",
            },
            step3: {
                title: "Получайте аналитику",
                description: "Следите за ценой километра, ежемесячными расходами и графиком обслуживания.",
            },
        },
        useCases: {
            title: "Идеально для",
            enthusiasts: {
                title: "Автолюбителей",
                description: "Отслеживайте каждую модификацию, номер детали и интервал обслуживания вашего проекта.",
            },
            dailyDrivers: {
                title: "Ежедневных поездок",
                description: "Знайте точно, сколько стоит ваша дорога, и никогда не пропускайте ТО.",
            },
            flippers: {
                title: "Умный перекупщик",
                description: "Создайте проверяемый объем данных, который докажет истинную ценность вашего автомобиля для покупателей.",
            },
            fleets: {
                title: "Малых автопарков",
                description: "Управляйте несколькими корпоративными авто в одном месте без сложного ПО.",
            },
        },
        foundersNote: {
            title: "Записка основателя",
            content: "Я создаю MyCarCosts, чтобы это был идеальный инструмент для людей, которые действительно заботятся о своих автомобилях. Не хватает ли вам какой-либо функции в вашем рабочем процессе? Свяжитесь со мной напрямую. Если это имеет смысл для сообщества, мы создадим это вместе.",
        },
        pricing: {
            freeLimitedTime: "Бесплатно на ограниченное время",
            title: "Простые и прозрачные цены",
            subtitle: "Начните бесплатно, переходите на новый уровень по мере роста.",
            perMonth: "мес.",
            monthly: "Ежемесячно",
            yearly: "Ежегодно",
            save25: "Сэкономьте 25%",
            billedAnnually: "Оплачивается ежегодно ({amount})",
            free: {
                title: "Бесплатно",
                cta: "Начать",
            },
            pro: {
                title: "Pro",
                cta: "Перейти на Pro",
                recommended: "Рекомендуем",
                earlyAdopter: "Цена раннего доступа",
                priceLock: "Зафиксируйте цену сейчас. В будущем она может вырасти.",
            },
            custom: {
                title: "Индивидуальный",
                cta: "Свяжитесь с нами",
            },
            features: {
                oneCar: "1 автомобиль",
                unlimitedExpenses: "Безлимитные расходы",
                unlimitedSpareParts: "Неограниченные запасные части",
                unlimitedNotes: "Неограниченные заметки",
                repeatedExpenses: "Повторяющиеся расходы",
                emailReminders: "Заметки и напоминания по запасным частям по электронной почте",
                basicStatistics: "Основная статистика",
                fullStatistics: "Полная статистика",
                storage50mb: "50 Мб хранилища файлов",
                unlimitedArchivedCars: "Неограниченные архивированные автомобили",
                dataExport: "Экспорт данных",
                allInFreePlus: "все в бесплатном плюс:",
                threeCars: "До 3 автомобилей",
                storage2gb: "2 Гб хранилища файлов",
                emailParsing: "Парсинг электронной почты",
                carAdmins: "Администраторы автомобилей",
                moreCars: "Больше автомобилей",
                moreFileStorage: "Больше хранилища файлов",
                customRequirements: "Индивидуальные требования",
            },
            upgradePopup: {
                title: "Скоро!",
                message: "Профессиональные и индивидуальные версии еще не запущены, но они будут скоро. Чтобы помочь нам запуститься быстрее, пожалуйста, напишите, какую конкретную функцию вы ожидаете от профессиональной / индивидуальной версии, или что-то еще, что вы хотели бы, чтобы мы улучшили, чтобы сделать эту платформу еще лучше для вас!",
                placeholder: "Напишите ваш отзыв здесь...",
                submit: "Отправить",
                cancel: "Отмена",
                thanksTitle: "Спасибо!",
                thanksMessage: "Мы получили ваш отзыв и будем работать над тем, чтобы сделать MyCarCosts еще лучше!",
                thanksOk: "Ок",
            },
        },
        migration: {
            title: "Переходите из Excel или другого приложения?",
            subtitle: "Мы предлагаем профессиональную услугу миграции данных, чтобы вы могли начать работу мгновенно.",
            pricingModel: "Модель ценообразования",
            small: {
                title: "Малый объем данных",
                description: "< 500 строк",
                price: "₽19–29",
            },
            medium: {
                title: "Средний объем данных",
                description: "500–5,000 строк",
                price: "₽49",
            },
            large: {
                title: "Большой / Сложный",
                description: "Устаревшие системы или сложные файлы",
                price: "Индивидуальный расчет",
            },
            process: {
                title: "Как это работает",
                step1: "Вы отправляете свой файл",
                step2: "Мы оцениваем данные",
                step3: "Разовый платеж",
                step4: "Мы выполняем импорт",
            },
            cta: "Запросить миграцию",
        },
        repairAnalysisSection: {
            title: "Ремонт или продажа? Пусть данные решат.",
            subtitle: "Профессиональный финансовый анализ вашего автомобиля. Прекратите гадать и начните знать, стоят ли эти ремонты действительно того.",
            features: {
                personalized: {
                    title: "Персонализированный анализ",
                    description: "Для ваших отслеживаемых автомобилей мы используем реальные исторические расходы и параметры, добавляя запланированные расходы для генерации оценки.",
                },
                public: {
                    title: "Публичный симулятор",
                    description: "Оцениваете потенциальную покупку? Используйте наш публичный инструмент на /repair, чтобы сгенерировать подробный анализ, введя всего несколько ключевых деталей.",
                },
                whatIf: {
                    title: "Симулятор 'Что если'",
                    description: "Введите планируемую стоимость ремонта и мгновенно увидьте, как это повлияет на финансовый рейтинг вашего автомобиля.",
                },
            },
            cta: "Посмотреть образец анализа",
        },
        faq: {
            title: "Часто задаваемые вопросы",
            subtitle: "Все, что вам нужно знать о My Car Costs",
            questions: {
                mobileApps: {
                    question: "Будут ли приложения для iOS и Android?",
                    answer: "Да! Мобильные приложения скоро появятся. Мы работаем над тем, чтобы предоставить вам лучший опыт.",
                },
                dataPrivacy: {
                    question: "Являются ли мои данные частными и защищенными?",
                    answer: "Абсолютно. Ваши данные зашифрованы и надежно хранятся.",
                },
                freePlan: {
                    question: "Действительно ли бесплатный план бесплатен навсегда?",
                    answer: "Да! Бесплатный план всегда будет доступен для одного авто. Перейдите на Pro для 3 авто и расширенных функций.",
                },
                dataExport: {
                    question: "Могу ли я экспортировать свои данные?",
                    answer: "Да, вы можете экспортировать все свои данные в любое время в формате CSV или PDF.",
                },
                emailImport: {
                    question: "Как работает импорт по электронной почте?",
                    answer: "Каждому авто присваивается уникальный email. Пересылайте ваши счета, и мы извлечем данные.",
                },
                multipleUsers: {
                    question: "Могут ли несколько человек иметь доступ к одному автомобилю?",
                    answer: "В настоящее время каждый автомобиль принадлежит одной учетной записи. Но вы можете сделать авто публичным.",
                },
            },
        },
        cta: {
            title: "Перестаньте гадать. Начните знать.",
            subtitle: "Превратите историю вашего авто в четкие финансовые решения. Присоединяйтесь к тысячам умных владельцев, которые точно знают, когда инвестировать, а когда продавать.",
            button: "Начать сейчас",
            note: "Без кредитной карты. Без навязчивых продаж. Только ясность.",
        },
        footer: {
            product: "Продукт",
            legal: "Юридическая информация",
            changelog: "Обновления",
            privacy: "Политика конфиденциальности",
            contact: "Контакт",
            contactEmail: "info@mycarcosts.com",
            questions: "Есть вопросы? Свяжитесь с нами по:",
        },
        privacy: {
            title: "Политика конфиденциальности",
            lastUpdated: "Обновлено: 24 марта 2026 г.",
            introduction: "В My Car Costs мы серьезно относимся к вашей конфиденциальности. Эта политика объясняет, как мы обрабатываем ваши данные в соответствии с современными стандартами конфиденциальности, включая GDPR.",
            dataCollection: {
                title: "Сбор данных",
                description: "Мы собираем только абсолютный минимум информации, необходимый для предоставления наших услуг.",
                email: "Идентификация аккаунта: Мы используем ваш адрес электронной почты в качестве уникального идентификатора и для целей аутентификации (например, магические ссылки или вход через Google).",
                documents: "Хранение документов: Файлы, которые вы загружаете, хранятся безопасно в зашифрованном облачном хранилище.",
            },
            carData: {
                title: "Ваш контроль над данными",
                description: "Информация, которую вы вводите (расходы, пробег, запчасти), хранится для вашего личного использования и аналитики.",
                noValidation: "Мы не проверяем предоставленные вами данные о автомобиле; вы несете ответственность за обеспечение их точности.",
                privateByDefault: "По умолчанию ваши данные являются частными. Технические идентификаторы файлов не являются последовательными и не индексируются поисковыми системами.",
                rightToForgotten: "Право на забвение: Вы можете удалить свою учетную запись в любое время, что немедленно и навсегда удаляет все ваши записи и файлы.",
            },
            thirdParty: {
                title: "Сторонние сервисы",
                description: "Мы не продаем ваши персональные данные. При использовании Google Login мы получаем доступ только к вашему электронному адресу для целей идентификации.",
            },
            emailIngestion: {
                title: "Обработка электронной почты",
                description: "Электронные письма, отправленные в нашу службу обработки, хранятся для истории. Вы можете вручную удалить отдельные электронные письма или всю историю в любое время.",
            },
        },
        emails: {
            deleteAll: "Удалить все",
            deleteAllConfirm: "Вы уверены, что хотите удалить всю историю электронной почты для этого автомобиля? Это действие необратимо.",
            deleteConfirm: "Вы уверены, что хотите удалить это электронное письмо?",
            noEmails: "Пока не получено ни одного электронного письма.",
        },
        terms: {
            title: "Условия использования",
            lastUpdated: "Обновлено: 25 марта 2026 г.",
            introduction: "Получая доступ к MyCarCosts или используя его, вы соглашаетесь соблюдать настоящие Условия использования. Если вы не согласны, пожалуйста, не пользуйтесь нашим сервисом.",
            acceptance: {
                title: "1. Принятие условий",
                description: "Настоящие условия представляют собой юридически обязательное соглашение между вами и MyCarCosts относительно использования вами нашего приложения и услуг.",
            },
            service: {
                title: "2. Описание услуги",
                description: "MyCarCosts предоставляет платформу для отслеживания расходов на транспортные средства, управления техническим обслуживанием и финансового анализа. Это включает в себя инструменты распознавания чеков на базе ИИ и визуализацию данных.",
            },
            responsibilities: {
                title: "3. Обязанности пользователя",
                description: "Вы несете ответственность за точность любых вводимых вами данных, включая пробег, VIN-номера и расходы. Вы должны обеспечивать безопасность своих учетных данных и не передавать их посторонним лицам.",
            },
            plans: {
                title: "4. Тарифные планы и лимиты",
                description: "Мы предлагаем Бесплатный и Pro планы с различными лимитами на хранилище, количество автомобилей и загрузки. Мы оставляем за собой право изменять эти лимиты или вводить новые уровни подписки в любое время.",
            },
            disclaimer: {
                title: "5. Отказ от ответственности и точность",
                description: "MyCarCosts является информационным и организационным инструментом. Мы не предоставляем официальных сертификатов состояния автомобиля. Данные, распознанные ИИ, всегда должны проверяться пользователем на точность.",
            },
            liability: {
                title: "6. Ограничение ответственности",
                description: "MyCarCosts предоставляется 'как есть'. Мы не несем ответственности за любые технические неисправности, финансовые потери или неточности данных, возникшие в результате использования нашего приложения.",
            },
            termination: {
                title: "7. Прекращение действия",
                description: "Вы можете прекратить использование сервиса и удалить свои данные в любое время. Мы оставляем за собой право приостановить или прекратить действие учетных записей, которые нарушают эти условия или допускают злоупотребления.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

